import { mergeModules } from "../core"
import reducer from "./reducer"

export default mergeModules({
  reducer,
})
